import React, { FC } from 'react'
import { IonHeader } from '@ionic/react'
import './index.scss'

interface IProps {
  className?: string;
  title?: string;
  onBack?: () => void;
  children?: any;
  cypid?: string;
}

const Header: FC<IProps> = ({ className, title, onBack, children, cypid }: IProps) => {
  return (
    <IonHeader>
      <div className={`element-page-header ${className || ''}`}>
        <div className='left-wrap'>
          {onBack && <div data-cypid={cypid || 'mmgCouponBack'} className='left-back' onClick={onBack}><i className='iconfont icon-BACK-12x'></i></div>}
          {title && <div className='title'>{title || ''}</div>}
        </div>
        {children}
      </div>
    </IonHeader>
  )
}

export default Header
